import { render, staticRenderFns } from "./MissingPage.vue?vue&type=template&id=5b5da6fe&scoped=true&lang=html&"
import script from "./MissingPage.vue?vue&type=script&lang=js&"
export * from "./MissingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5da6fe",
  null
  
)

export default component.exports